export default __webpack_public_path__ + "images/models/48d52a64bc203649b1cdba7f85a1508c.glb";